const lang={
    "English":{
        search:"Search",
        searchPlaceholder:"What would you like to watch today ?",
    },
    "Hindi":{
        search:"खोज",
        searchPlaceholder:"आज आप क्या देखना चाहेंगे?",
    },
    "Spanish":{
        search:"Buscar",
        searchPlaceholder:"¿Qué te gustaría ver hoy?",
    }
}
export default lang;